export const routeNameIsLocalized = payload => {
  const { routeName } = payload

  return routeName.includes('___') ? true : false
}
